import EventEmitter from 'wolfy87-eventemitter';
import isUndefined from 'lodash/isUndefined';
import { inject } from 'inversify';
import { BACKGROUND_MODULE_IDS } from '../background/background.types';
import type { IBackgroundController } from '../background/background.interface';

interface PanParams {
  offsetX: number;
  offsetY: number;
  diffX?: number;
  diffY?: number;
  onEnd?: () => void;
}

export class DragController extends EventEmitter {
  startX: number;
  startY: number;

  @inject(BACKGROUND_MODULE_IDS.BACKGROUND_CONTROLLER)
  public backgroundController: IBackgroundController;

  pan({ offsetX, offsetY, diffX, diffY, onEnd }: PanParams) {
    if ((!isUndefined(diffX) || !isUndefined(diffY)) && (offsetX !== diffX || offsetY !== diffY)) {
      window.Widget.moveSchemeBack({
        offsetX,
        offsetY,
        diffX,
        diffY,
        onEnd: () => {
          if (offsetX || offsetY) {
            window.Widget.clear();
            window.Widget.pan({ offsetX, offsetY });
            this.backgroundController.update();
          }

          if (onEnd) onEnd();
        },
      });
      return;
    }

    if (offsetX || offsetY) {
      window.Widget.clear();
      window.Widget.pan({ offsetX, offsetY });
      this.backgroundController.update();
    }

    window.Widget.resetStyles();
    if (onEnd) onEnd();
  }

  moveTo({ x, y }) {
    window.Widget.moveTo(x, y);
    window.Widget.update();
    this.backgroundController.update();
  }
}
